import { SYSTEM_HELP, preloadWebItemLocation } from '@confluence/web-item-location';
import { HelpPanelQuery } from '@confluence/in-product-help';
import { query, waitForAllReturnWhenError } from '@confluence/query-preloader-tools';

export const preloadHelpMenu = () => {
	return waitForAllReturnWhenError([
		preloadWebItemLocation({ location: SYSTEM_HELP }),
		query({ query: HelpPanelQuery }),
	]);
};
